import React, { useState } from 'react';

/* MobX */
import { observer } from 'mobx-react-lite';

/* MUI */
import { makeStyles } from '@material-ui/core/styles';
import { Container, Tabs, Tab, Paper } from '@material-ui/core';

/* Langan Components */
import CreateUser from './CreateUser';
import AssignRole from './AssignRole';
import UpdateUser from './UpdateUser';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
  wrapper: {
    textTransform: 'initial'
  }
}));

const ManageUsers = observer(props => {
  const classes = useStyles();

  // To handle tabs:
  const [selectedTab, setSelectedTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  }

  // const [showPassword, setShowPassword] = useState(false);
  // const handleShowPassword = () => setShowPassword(!showPassword);

  return (
    <Container maxWidth="md">
      <Paper className={classes.paper}>
        <Tabs value={selectedTab} onChange={handleTabChange}>
          <Tab label="Create New User" className={classes.wrapper}/>
          <Tab label="Role Assignment" className={classes.wrapper}/>
          <Tab label="Update User" className={classes.wrapper}/>
        </Tabs>
        {selectedTab === 0 &&
          <CreateUser />
        }
        {selectedTab === 1 &&
          <AssignRole />
        }
        {selectedTab === 2 &&
          <UpdateUser />
        }
      </Paper>
    </Container>
  )
});

export default ManageUsers;
